import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';

import {ColorPickerModule} from 'ngx-color-picker'
import {Autosize} from 'angular2-autosize/angular2-autosize';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MdButtonModule, MdIconModule, MdSelectModule, MdProgressSpinnerModule} from '@angular/material';

import {AppComponent} from './app.component';

import {SettingService} from "./service/setting.service";
import { SettingsComponent } from './settings/settings/settings.component';
import { AnalyticsComponent } from './analytics/analytics/analytics.component';
import {VoteService} from "./service/vote.service";

@NgModule({
    declarations: [
        AppComponent,
        Autosize,
        SettingsComponent,
        AnalyticsComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        ColorPickerModule,
        BrowserAnimationsModule,
        MdButtonModule,
        MdIconModule,
        MdSelectModule,
        MdProgressSpinnerModule

    ],
    providers: [
        SettingService,
        VoteService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts